<p-dialog
  [header]="planType.label"
  [modal]="true"
  [(visible)]="visible"
  [closable]="false"
  [style]="{ width: '90%', 'max-width': '700px', 'max-height': '80%' }"
>
  <div class="content">
    <div class="body">
      <div class="flex width-100 align-center">
        <div class="flex flex-1 flex-center" style="font-size: 1.1rem; font-weight: 600">Month</div>
        <div class="flex flex-1 flex-center" style="font-size: 1.1rem; font-weight: 600">Proj</div>
        <div class="flex flex-1 flex-center" style="font-size: 1.1rem; font-weight: 600">Imax</div>
      </div>
      @for (record of previewPlanTable; track $index; let last = $last) {
      <div class="flex width-100 align-center">
        <div class="flex flex-1 flex-center">{{ record.month }}</div>
        <div class="flex flex-1 flex-center">{{ record.proj | minutesToTime }}</div>
        <div class="flex flex-1 flex-center">{{ record.imax | minutesToTime }}</div>
      </div>
      }
    </div>
    <div class="flex flex-end gap-05 width-100">
      <app-button label="Cancel" [text]="true" [outlined]="true" (click)="closeDialog()" />
      <app-button
        label="Create"
        [disabled]="presetPlansService.isLoading()"
        [outlined]="globalService.theme() === 'dark'"
        (click)="createPlan()"
      />
    </div>
  </div>
</p-dialog>
